import { render } from "./RankingStatistics.vue?vue&type=template&id=33db6336&scoped=true&ts=true"
import script from "./RankingStatistics.vue?vue&type=script&lang=ts"
export * from "./RankingStatistics.vue?vue&type=script&lang=ts"

import "./RankingStatistics.vue?vue&type=style&index=0&id=33db6336&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33db6336"]])

export default __exports__